import * as React from 'react'

/**
 * @description Verification icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Verification } from '@sravni/design-system-icons'
 *
 * <Verification />
 * ```
 */
export const Verification = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Verification" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.832 1.06-2.45.793a1.232 1.232 0 0 1-.764 0l-2.45-.792a1.241 1.241 0 0 0-1.486.615L4.51 3.97a1.237 1.237 0 0 1-.54.541L1.676 5.681a1.242 1.242 0 0 0-.616 1.488l.793 2.448c.08.249.08.516 0 .764l-.793 2.45a1.24 1.24 0 0 0 .615 1.487L3.97 15.49c.233.118.422.308.541.54l1.171 2.294a1.24 1.24 0 0 0 1.487.615l2.45-.793c.248-.08.515-.08.764 0l2.45.793a1.24 1.24 0 0 0 1.486-.615l1.172-2.293c.119-.233.309-.422.54-.541l2.294-1.171a1.24 1.24 0 0 0 .615-1.487l-.793-2.45a1.245 1.245 0 0 1 0-.764L18.93 7.2a1.279 1.279 0 0 0-.635-1.532L16.031 4.51a1.242 1.242 0 0 1-.541-.54l-1.171-2.294a1.24 1.24 0 0 0-1.487-.615Zm1 6.18a.6.6 0 0 0-.846.06l-3.76 4.331L6.647 9.24l-.086-.067a.6.6 0 0 0-.73.946l3.032 2.813.087.068a.6.6 0 0 0 .774-.114l4.168-4.8.063-.088a.6.6 0 0 0-.123-.758Z"
      fill="currentColor"
    />
  </svg>
))
